<template>
  <div class="wspo-countries">
    <div class="wspo-countries-headline">Страны</div>
    <div
      class="wspo-countries-item"
      @click="setCountry(null)"
      :class="{ 'wspo-selected': isSelected(null) }"
    >
      Все
    </div>
    <div
      class="wspo-countries-item"
      v-for="country in countriesByType"
      :key="country.id"
      @click="setCountry(country.id)"
      :class="{ 'wspo-selected': isSelected(country.id) }"
    >
      {{ country.name }}
      <div
        v-if="isImportant(country.id)"
        class="wspo-important wspo-icon"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'Countrylist',
  computed: {
    ...mapGetters(['countriesByType']),
    ...mapState(['country', 'countries'])
  },
  // watch: {
  //   countriesByType(newCountries) {
  //     if (!newCountries.find(country => country.id === this.country))
  //       this.setCountry(newCountries[0].id);
  //   }
  // },
  methods: {
    ...mapMutations(['setCountry']),
    isSelected(id) {
      return id ? this.country === id : !this.country;
    },
    isImportant(id) {
      if (new Date().getMonth() > 8 || new Date().getMonth() === 0) {
        // if (id === '1872') return true; // Egypt
        if (id === '1842') return true; // Thai
      } else if (id === '1873') return true;
    }
  }
};
</script>

<style scoped>
.wspo-countries {
  padding: 4px 0;
  width: 100%;
}
.wspo-countries-headline {
  padding: 0 18px 8px;
  font-weight: 700;
  color: var(--color-text-5);
}
.wspo-countries-item {
  padding: 4px 18px;
  cursor: pointer;
  border: 1px solid var(--color-bg);
  display: flex;
}
.wspo-countries-item:hover:not(.wspo-selected) {
  background: var(--color-bg-dark);
  border: 1px solid var(--color-alt-5);
  cursor: pointer;
}
.wspo-selected {
  background-color: var(--color-main);
  border-color: var(--color-main);
  color: var(--color-paper);
  cursor: default;
}
.wspo-important {
  margin-left: 8px;
}
.wspo-important:before {
  content: '\f7e4';
  color: var(--color-third);
}
</style>
